import { IBenefitDTO } from '../../dto/benefits/benefit.dto';
import { IBenefitsDTO } from '../../dto/benefits/benefits.dto';

const benefitDTOs: IBenefitDTO[] = [
  {
    title: $localize`:@@page-story-viewer-content-benefits-section-option-0-title:Commitment to anonymity`,
    value: $localize`:@@page-story-viewer-content-benefits-section-option-0-value:Our service allows you to watch Instagram stories anonymously, keeping your actions completely hidden. With our tool, you can explore stories without fearing being noticed.`,
  },
  {
    title: $localize`:@@page-story-viewer-content-benefits-section-option-1-title:No registration required`,
    value: $localize`:@@page-story-viewer-content-benefits-section-option-1-value:There’s no need to sign up or share personal information to use our Instagram story viewer. Just enter the username and start viewing content instantly!`,
  },
  {
    title: $localize`:@@page-story-viewer-content-benefits-section-option-2-title:User-friendly interface`,
    value: $localize`:@@page-story-viewer-content-benefits-section-option-2-value:Our story viewer is designed with simplicity in mind. The interface is user-friendly, making it easy for anyone, even those less familiar with technology, to navigate and find what they’re looking for. You can browse Instagram stories anonymously with a few clicks.`,
  },
  {
    title: $localize`:@@page-story-viewer-content-benefits-section-option-3-title:Any device`,
    value: $localize`:@@page-story-viewer-content-benefits-section-option-3-value:Use our versatile Instagram story viewer on any device — mobile, tablet, PC. The service works smoothly across all platforms, so you can start watching stories anonymously from anywhere using your browser.`,
  },
  {
    title: $localize`:@@page-story-viewer-content-benefits-section-option-4-title:Option to download`,
    value: $localize`:@@page-story-viewer-content-benefits-section-option-4-value:You can watch and download any Instagram story anonymously with our service! Just enter the username, and you'll have access to all the available content.`,
  },
];

export const benefitsDTO: IBenefitsDTO = {
  title: $localize`:@@page-story-viewer-content-benefits-section-title:Key features of our Instagram story viewer`,
  benefits: benefitDTOs,
};
